/**
 * This is just a object
 */
export var pageView = {
  event: 'page_view',
  detailed_event: 'Page Load Completed'
};